import * as types from '../actions/types';

const initialState = {
    wait: false,
    data: [],
    selected: null,
    error: null,
};

export default function (state=initialState, {type, payload}) {
    switch (type) {
      // get
        case types.GET_ALL_PROJECTS_WAIT:
            return {
                ...state,
                wait: true,
            };
        case types.GET_ALL_PROJECTS_SUCCESS:
            return {
                ...state,
                wait: false,
                data: [...payload],
            };
        case types.GET_ALL_PROJECTS_ERROR:
            return {
                ...state,
                wait: false,
                data: [],
            };

      // POST
        case types.CREATE_PROJECT_WAIT:
            return {
                ...state,
                wait: true,
            };
        case types.CREATE_PROJECT_SUCCESS:
            return {
                ...state,
                wait: false,
                selected: payload,
            };
        case types.CREATE_PROJECT_ERROR:
            return {
                ...state,
                wait: false,
                error: payload,
            };

      // PATCH
        case types.PATCH_PROJECT_WAIT:
            return {
                ...state,
                wait: true,
            };
        case types.PATCH_PROJECT_SUCCESS:
            return {
                ...state,
                wait: false,
                selected: payload,
            };
        case types.PATCH_PROJECT_ERROR:
            return {
                ...state,
                wait: false,
            };
      // DELETE
        case types.DELETE_PROJECT_WAIT:
            return {
                ...state,
                wait: true,
            };
        case types.DELETE_PROJECT_SUCCESS:
            return {
                ...state,
                wait: false,
            };
        case types.DELETE_PROJECT_ERROR:
            return {
                ...state,
                wait: false,
                error: payload,
            };
      // GET ONE
        case types.GET_PROJECT_WAIT:
            return {
                ...state,
                wait: true,
                error: null,
            };
        case types.GET_PROJECT_SUCCESS:
            return {
                ...state,
                wait: false,
                selected: payload,
            };
        case types.GET_PROJECT_ERROR:
            return {
                ...state,
                wait: false,
                error: payload,
            };
        default:
            return state;
    }
}
